// extracted by mini-css-extract-plugin
export default {"Badge":"kcb3qSho","BadgeDisabled":"suRWflJa","Content":"rmC65j6f"};